import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  List,
  ListItem,
  ListItemPrefix,
  Switch,Button
} from "@material-tailwind/react";
// import {
//   IdentificationIcon,
//   HomeModernIcon,
//   MagnifyingGlassIcon,
//   DocumentTextIcon,
//   HandThumbUpIcon,
//   CurrencyDollarIcon,
//   TableCellsIcon,
//   QuestionMarkCircleIcon,
//   WalletIcon,
//   ArchiveBoxIcon,
// } from "@heroicons/react/24/outline";

import { UserCircleIcon, UserPlusIcon } from "@heroicons/react/24/outline";

import {
  IdentificationIcon,
  InboxStackIcon,
  CalendarDaysIcon,
  ArchiveBoxIcon,
  UserGroupIcon,          // Obreros / Padrón
  HomeModernIcon,         // Iglesias
  ClipboardDocumentListIcon,    // Búsqueda / Consultas
  BriefcaseIcon,          // Trámites (Maletín de gestión)
  PaperClipIcon,           // Anexos (Clip de adjuntos)
  ChartBarIcon,           // Informes (Gráfico de estadísticas)
  BanknotesIcon,          // Caja (Efectivo/Movimientos)
  ReceiptPercentIcon,     // Aranceles (Tasas / Impuestos)
  ScaleIcon,              // Cuentas Corrientes (Balanza de saldos)
  AdjustmentsHorizontalIcon,              // Historial / Archivos anteriores
  ShieldCheckIcon,        // Seguridad / Auditoría
  QuestionMarkCircleIcon, // Soporte / Ayuda
  CommandLineIcon,        // Reportes / Procedimientos (consola de SPs)
} from "@heroicons/react/24/outline";

import { NavLink } from 'react-router-dom';
import { ArrowDownIcon, ChevronRightIcon, PowerIcon } from "@heroicons/react/24/solid";
import { Modal, useModal } from '../Helpers/importacionesComunes'
import Ejemplo from './Ejemplo';
import Asambleas from './Asambleas';
import { CambioPassword } from './CambioPassword';
import { Evento } from '../Vistas/eventos/vistas/Evento';
import { Tramites } from '../Vistas/tramites/vistas/Tramites';
import { Cupones } from '../Vistas/cupones/vistas/Cupones';
import Axios from 'axios';
import { useContextoGlobal } from "../Context/contextoGlobal";
import ScreenDebug from "./ScreenDebug";
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';

export function MenuSidebar({ usuario, logout, displaySidebar = false }) {
  const [open, setOpen] = React.useState(0);
  const [hoveredIcon, setHoveredIcon] = useState('');
  const [hoveredSubMenu, setHoveredSubMenu] = useState('');
  const [componenteModal, setComponenteModal] = useState(null);
  const [titulo, setTitulo] = useState('');
  const [abrirMenuVertical, setAbrirMenuVertical] = useState(false)
  const { toggle, isShowing } = useModal();
  const { ocultarMenu :ocultarMenuGlobal,activeMenu, setCurrentMenu } = useContextoGlobal();
  const [parametros,setParametros]=useState({screendebug:false})

  const handleMouseEnter = (id) => {
    setHoveredIcon(id);
  };

  const ocultarMenu = (tieneSubMenu)=>{
    if(!tieneSubMenu){
        ocultarMenuGlobal();
    }
  }

  const handleHoveredSubMenu = (id) => {
    setHoveredSubMenu(id);
  };

  const handleMouseLeave = () => {
    setHoveredIcon("");
  };

  const handleClick = (id)=>{
    if(id===activeMenu){
        setCurrentMenu("")
    }else{
        setCurrentMenu(id)
    }
  }

  const handleClickSubMenu = (event,id)=>{
    handleHoveredSubMenu(id); 
    event.stopPropagation();
    ocultarMenu()
  }

  if(usuario.rol_sede == 2) // usuarios colaboradores
    return (
      <Card className={`min-h-screen w-full max-w-[16rem] p-4 shadow-xl shadow-blue-gray-900/5 !rounded-none
        ${displaySidebar ? 'flex' : 'hidden 4xl:flex'}`}>
        <div className="flex flex-col lg:hidden mb-[-15px] p-4 !text-[#2196f3]">
          <Typography variant="h5" className="w-full">
            Bienvenido
          </Typography>
          <Typography variant="h5" className="w-full !font-bold">
            {`${usuario.nombre}`}
          </Typography>
        </div>
        <List className="overflow-y-auto">
          <hr className="my-2 border-blue-gray-50 flex lg:hidden" />
          <ListItem
            className={`block flex-col justify-start cursor-pointer ${activeMenu === 'type1' ? '!bg-blue-gray-50' : ''}`}
            onClick={() => { handleClick('type1'); ocultarMenu() }}
          >
            <NavLink to="/asambleas">
              <div className="flex flex-row">
                <ListItemPrefix>
                  <IdentificationIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
                </ListItemPrefix>
                <p className="font-semibold">Asambleas</p>
              </div>
              <div className={`${hoveredIcon === 'type1' || activeMenu === 'type1' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
                  Gestione asambleas
              </div>
            </NavLink>
  
          </ListItem>
          <ListItem
            className={`block flex-col justify-start cursor-pointer ${activeMenu === 'type12' && 'bg-blue-gray-50'}`}
            onClick={() => { handleClick('type12'); ocultarMenu() }}
          >
            <button className="p-0" title="Salir" onClick={logout}>
              <div className="flex flex-row space-x-6 p-0">
                <PowerIcon className="h-5 w-5" />
                <p className="font-semibold">Salir</p>
              </div>
            </button>
          </ListItem>
        </List>
        {isShowing &&
          <Modal
            hide={toggle} isShowing={isShowing} titulo={titulo} estiloWrapper={{ background: '#000000bf' }}>
            <SeleccionarComponenteModal componente={componenteModal}
              usuario={usuario}
            />
          </Modal>}
      </Card>
    );

  return (
    <Card className={`min-h-screen w-full max-w-[16rem] p-4 shadow-xl shadow-blue-gray-900/5 !rounded-none
      ${displaySidebar ? 'flex' : 'hidden 4xl:flex'}`}>
      <div className="flex flex-col lg:hidden mb-[-15px] p-4 !text-[#2196f3]">
        <Typography variant="h5" className="w-full" >
          Bienvenido
        </Typography>
        <Typography variant="h5" className="w-full !font-bold">
          {`${usuario.nombre}`}
        </Typography>
      </div>
      <List className="overflow-y-auto">
        <hr className="my-2 border-blue-gray-50 flex lg:hidden" />
        <ListItem
          className={`block flex-col justify-start cursor-pointer ${activeMenu === 'type1' ? '!bg-blue-gray-50' : ''}`}
          onClick={() => { handleClick('type1'); ocultarMenu() }}
        >
          <NavLink to="/ministros">
            <div className="flex flex-row">
              <ListItemPrefix>
                <UserGroupIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
              </ListItemPrefix>
              <p className="font-semibold">Ministros</p>
            </div>
            <div className={`${hoveredIcon === 'type1' || activeMenu === 'type1' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
              Acceda a la Lista de Ministros y actualice la información
            </div>
          </NavLink>

        </ListItem>
        <ListItem
          className={`block flex-col justify-start cursor-pointer ${activeMenu === 'type2' && 'bg-blue-gray-50'}`}
          onClick={() => { handleClick('type2'); ocultarMenu() }}
        >
          <NavLink to="/iglesias">
            <div className="flex flex-row">
              <ListItemPrefix>
                <HomeModernIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
              </ListItemPrefix>
              <p className="font-semibold">Iglesias</p>
            </div>
            <div className={`${hoveredIcon === 'type2' || activeMenu === 'type2' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
              Acceda a la Lista de Iglesias y actualice la información
            </div>
          </NavLink>
        </ListItem>

        {/* Vista mock — Disparador de Stored Procedures (reportes parametrizables) */}
        <ListItem
          className={`block flex-col justify-start cursor-pointer ${activeMenu === 'type-reportes-sp' && 'bg-blue-gray-50'}`}
          onClick={() => { handleClick('type-reportes-sp'); ocultarMenu() }}
        >
          <NavLink to="/reportes-sp">
            <div className="flex flex-row">
              <ListItemPrefix>
                <CommandLineIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
              </ListItemPrefix>
              <p className="font-semibold">Reportes SP</p>
            </div>
            <div className={`${hoveredIcon === 'type-reportes-sp' || activeMenu === 'type-reportes-sp' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
              Ejecute procedimientos parametrizables y exporte los resultados
            </div>
          </NavLink>
        </ListItem>

        <ListItem
          selected={open === 1}
          className={`block flex-col justify-start ${activeMenu === 'type3' && 'bg-blue-gray-50 border-0'}`}
          onClick={() => { handleClick('type3'); ocultarMenu('sub-menu-gestiones-regionales') }}
        >
          <div className="flex">
            <ListItemPrefix>
              <ArchiveBoxIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
            </ListItemPrefix>
            <p className="font-semibold">Gestiones <br></br> regionales</p>
          </div>
          <div className={`${hoveredIcon === 'type3' || activeMenu === 'type3' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
            <List className="p-0 max-w-[16rem] min-w-[130px]">
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub1' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub1")}}
                >
                <NavLink to="/ingresos-r">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Ingresos
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub2' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub2")}}
                >
                <NavLink to="/depositos-sin-identificar">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Depósitos sin identificar
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub3' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub3")}}
                >
                <NavLink to="/reporte-ha">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Historial de Aportes
                  </div>
                </NavLink>
              </ListItem>      
              {usuario.perfil==='region' && <>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub110' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub110")}}
                >
                  <NavLink to="/ingresos-t">
                    <div className="flex flex-row">
                      <ListItemPrefix>
                        <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                      </ListItemPrefix>
                        Reporte de Ingresos
                    </div>
                  </NavLink>
              </ListItem>              
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub114' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub114")}}
                >
                <NavLink to="/asambleas">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                      Gestione Asambleas 
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub4' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub4")}}
                >
                <NavLink to="/documentos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Documentos
                  </div>
                </NavLink>
              </ListItem></>}     
            </List>
          </div>
        </ListItem>

        {usuario?.perfil==='sede' && <ListItem
          selected={open === 1}
          className={`block flex-col justify-start ${activeMenu === 'type4' && 'bg-blue-gray-50 border-0'}`}
          onClick={() => { handleClick('type4'); ocultarMenu('sub-menu-tesoreria') }}
        >
          <div className="flex">
            <ListItemPrefix>
              <BanknotesIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
            </ListItemPrefix>
            <p className="font-semibold">Tesorería</p>
          </div>
          <div className={`${hoveredIcon === 'type4' || activeMenu === 'type4' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
            <List className="p-0 max-w-[16rem] min-w-[130px]">
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub5' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"type500")}}
                >
                  <NavLink to="/ingresos-t">
                    <div className="flex flex-row">
                      <ListItemPrefix>
                        <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                      </ListItemPrefix>
                      Ingresos
                    </div>
                  </NavLink>
              </ListItem>
              
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub14' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub14")}}
                >
                <NavLink to="/reportes-ii">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Reporte de Ingresos
                  </div>
                </NavLink>
              </ListItem>

              {usuario?.perfil==='sede' && <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub5' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"type5")}}
                >
                <NavLink to="/egresos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Egresos
                  </div>
                </NavLink>
              </ListItem>}

              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub13' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub13")}}
              >
                <NavLink to="/reportes-ei">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Reporte de Egresos
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub135' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub135")}}
              >
                <NavLink to="/reportes-obap">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                      Aportantes
                  </div>
                </NavLink>
              </ListItem>              
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub776' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub776")}}
                >
                <NavLink to="/libros-fet">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Libro FET
                  </div>
                </NavLink>
              </ListItem>

              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub8' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub8")}}
                >
                <NavLink to="/interdepositos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Interdepósitos
                  </div>
                </NavLink>
              </ListItem>

              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub7' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub7")}}
                >
                <NavLink to="/proveedores">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Proveedores
                  </div>
                </NavLink>
              </ListItem>
            </List>
          </div>
        </ListItem>}

        {usuario?.perfil==='sede' && <ListItem
          selected={open === 1}
          className={`block flex-col justify-start ${activeMenu === 'type8' && 'bg-blue-gray-50 border-0'}`}
          onClick={() => { handleClick('type8'); ocultarMenu('sub-menu-secretaria') }}
        >
          <div className="flex">
            <ListItemPrefix>
              <InboxStackIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
            </ListItemPrefix>
            <p className="font-semibold">Secretaría</p>
          </div>
          <div className={`${hoveredIcon === 'type8' || activeMenu === 'type8' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
            <List className="p-0 max-w-[16rem] min-w-[130px]">
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub16' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub16")}}
                >
                <NavLink to="/alertas">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Alertas
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`hidden flex-col justify-start ${hoveredSubMenu === 'sub17' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub17")}}
                >
                <NavLink to="/ejemplo">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Archivo
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub19' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub19")}}
                >
                <NavLink to="/envio-emails">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Envio Emails
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub20' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub20")}}
                >
                <NavLink to="/reset-passwords">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                        Reiniciar contraseñas
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'subzx14' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"subzx14")}}
                >
                <NavLink to="/delegados">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                        Delegados por iglesia 
                  </div>
                </NavLink>
              </ListItem>   
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub3x20' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub3x20")}}
                >
                <NavLink to="/tramites">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <BriefcaseIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                        Trámites Versión inicial
                  </div>
                </NavLink>
              </ListItem>   
            </List>
          </div>
        </ListItem>}
        {usuario?.perfil==='sede' && <ListItem
          selected={open === 1}
          className={`block flex-col justify-start ${activeMenu === 'typeza999' && 'bg-blue-gray-50 border-0'}`}
          onClick={() => { handleClick('typeza999'); ocultarMenu('sub-menu-eventos') }}
        >
          <div className="flex">
            <ListItemPrefix>
              <UserCircleIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
            </ListItemPrefix>
            <p className="font-semibold">Usuarios</p>
          </div>
          <div className={`${hoveredIcon === 'typeza999' || activeMenu === 'typeza999' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
            <List className="p-0 max-w-[16rem] min-w-[130px]">
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub21-za999' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub21-za999")}}
                >
                <NavLink to="/usuarios">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                      Listado y gestión
                  </div>
                </NavLink>
              </ListItem>     
            </List>
          </div>
        </ListItem>}
        {usuario?.perfil==='sede' && <ListItem
          selected={open === 1}
          className={`block flex-col justify-start ${activeMenu === 'type9' && 'bg-blue-gray-50 border-0'}`}
          onClick={() => { handleClick('type9'); ocultarMenu('sub-menu-eventos') }}
        >
          <div className="flex">
            <ListItemPrefix>
              <CalendarDaysIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
            </ListItemPrefix>
            <p className="font-semibold">Eventos</p>
          </div>
          <div className={`${hoveredIcon === 'type9' || activeMenu === 'type9' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
            <List className="p-0 max-w-[16rem] min-w-[130px]">
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub21' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub21")}}
                >
                <NavLink to="/eventos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                      Listado y gestión
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub022' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub022")}}
                >
                <NavLink to="/pfrecuentes">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                      Preguntas frecuentes
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub22' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub22")}}
                >
                <NavLink to="/reset-passwords">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Reiniciar contraseñas
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub23' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub23")}}
                >
                <NavLink to="/asambleas">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Asambleas
                  </div>
                </NavLink>
              </ListItem> 
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'subx14' && 'bg-blue-gray-100'}`}
                //onClick={() => { handleHoveredSubMenu("sub4"); ocultarMenu() }}
                onClick={(event) => { handleClickSubMenu(event,"subx14")}}
                >
                <NavLink to="/delegados">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                        Delegados por iglesia 
                  </div>
                </NavLink>
              </ListItem>              
            </List>
          </div>
        </ListItem>}
        {usuario?.perfil==='sede' && <ListItem
          selected={open === 1}
          className={`block flex-col justify-start ${activeMenu === 'type10' && 'bg-blue-gray-50 border-0'}`}
          onClick={() => { handleClick('type10'); ocultarMenu('sub-menu-configuracion') }}
        >
          <div className="flex">
            <ListItemPrefix>
              <AdjustmentsHorizontalIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
            </ListItemPrefix>
            <p className="font-semibold">Configuración</p>
          </div>
          <div className={`${hoveredIcon === 'type10' || activeMenu === 'type10' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
            <List className="p-0 max-w-[16rem] min-w-[130px]">
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub5' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub5")}}
                >
                <NavLink to="/bancos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Bancos
                  </div>
                </NavLink>
              </ListItem>
              
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub9' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub9")}}
                >
                <NavLink to="/rubro-egresos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Cuentas de Egresos
                  </div>
                </NavLink>
              </ListItem>

              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub10' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub10")}}
                >
                <NavLink to="/rubro-ingresos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Cuentas de Ingresos
                  </div>
                </NavLink>
              </ListItem>
              
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub12' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub12")}}
                >
                <NavLink to="/destino-ingresos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Distribución de Ingresos (%)
                  </div>
                </NavLink>
              </ListItem>

              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub24' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub24")}}
                >
                <NavLink to="/documentos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Documentos
                  </div>
                </NavLink>
              </ListItem>

              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub11' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub11")}}
                >
                <NavLink to="/fondos-tesoreria">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Fondos de Tesorería
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub6' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub6")}}
                >
                <NavLink to="/cajas-rubros">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    FET
                  </div>
                </NavLink>
              </ListItem>              
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub25' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub25")}}
                >
                <NavLink to="/nacionalidades">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Nacionalidades
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub26' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub26")}}
                >
                <NavLink to="/partidos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Partidos
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub27' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub27")}}
                >
                <NavLink to="/provincias">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Provincias
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub28' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub28")}}
                >
                <NavLink to="/rangos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Rangos
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub29' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub29")}}
                >
                <NavLink to="/regiones">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Regiones
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub299' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub299")}}
                >
                <NavLink to="/distritos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Distritos
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub300' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub300")}}
                >
                <NavLink to="/estados-civiles">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Estados Civiles
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub301' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub301")}}
                >
                <NavLink to="/tipo-iglesias">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Tipo Iglesias
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub302' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub302")}}
                >
                <NavLink to="/tipo-documentos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Tipo Documentos
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub304' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub304")}}
                >
                <NavLink to="/cajas-uad">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Cajas UAD
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub305' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub305")}}
                >
                <NavLink to="/cuentas-bancarias-uad">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Cuentas Bancarias UAD
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub306' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub306")}}
                >
                <NavLink to="/parametros-sistema">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Parámetros del Sistema
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub30' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub30")}}
                >
                <NavLink to="/tandas">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Tandas
                  </div>
                </NavLink>
              </ListItem>
              <ListItem className={`block flex-col justify-start ${hoveredSubMenu === 'sub31' && 'bg-blue-gray-100'}`}
                onClick={(event) => { handleClickSubMenu(event,"sub31")}}
                >
                <NavLink to="/tipo-comprobante-egresos">
                  <div className="flex flex-row">
                    <ListItemPrefix>
                      <ChevronRightIcon strokeWidth={3} className="h-3 w-5" />
                    </ListItemPrefix>
                    Tipo de Comprobante de Egresos
                  </div>
                </NavLink>
              </ListItem>
            </List>
          </div>
        </ListItem>}

        <ListItem
          className={`block flex-col justify-start cursor-pointer ${activeMenu === 'type11' && 'bg-blue-gray-50'}`}
          onClick={() => { handleClick('type11'); ocultarMenu() }}
        >
          {/* <NavLink to="/tramites"> */}
          <NavLink to="/tramites-new/1.0">
            <div className="flex flex-row">
              <ListItemPrefix>
                <ClipboardDocumentListIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
              </ListItemPrefix>
              <p className="font-semibold">Trámites Nueva Versión</p>
            </div>
            <div className={`${hoveredIcon === 'type11' || activeMenu === 'type11' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
              Realice gestiones administrativas dentro de la asociación
            </div>
          </NavLink>
       </ListItem>
      {/* <ListItem 
        className={`block flex-col justify-start cursor-pointer ${activeMenu === 'xsue13x20' ? 'bg-blue-gray-50' : ''}`}
        onClick={() => { handleClick('xsue13x20'); ocultarMenu(); }}
      >
        <NavLink to="/tramites-new/2.0">
          <div className="flex flex-row">
            <ListItemPrefix>
              <BriefcaseIcon className="relative top-[-2px] h-6 w-6 text-[#111]" />
            </ListItemPrefix>
            <p className="font-semibold text-red-400">Versión Beta Trámites</p>
          </div>
          <div className={`${hoveredIcon === 'xsue13x20' || activeMenu === 'xsue13x20' ? 'flex' : 'hidden'} text-[15px] text-[#0595D0] pt-2 px-3`}>
            Nueva interface (Disponible sólo para Ascensos)
          </div>
        </NavLink>
      </ListItem>           */}
        {[1,28].some(i=>i==usuario.id_usuario) && 
        <li title="Logs" className="Nav__link-push">
          <div className="text-center">
            <NavLink title='Estadísticas' activeClassName="op-active" className="Nav__link" to="/logs">
              <p className="text-large color-63 text-center">Logs</p>
            </NavLink>
          </div>
           <Button title="Use esta función para testear si el servicio de mensajería SMS funciona correctamente. Se enviará un SMS de prueba" onClick={enviarCodigo}> Probar mensajería</Button>
        </li>}        
        <ListItem
          className={`block flex-col justify-start cursor-pointer ${activeMenu === 'type12' && 'bg-blue-gray-50'}`}

          onClick={() => { handleClick('type12'); ocultarMenu() }}
        >
          <button className="p-0" title="Salir" onClick={logout}>
            <div className="flex flex-row space-x-6 p-0">
              <PowerIcon className="h-5 w-5" />
              <p className="font-semibold">Salir</p>
            </div>
          </button>
        </ListItem>
       <ListItem
        >
          <Switch
            label="Mi monitor"
              title="Visualice la configuración de su monitor"
              ripple={false}
              name="screendebug"
              checked={parametros.screendebug}
              onChange={(e) => { 
                  setParametros({ ...parametros, screendebug: e.target.checked ? true : false })
              }}
          />
        </ListItem>        
      </List>
      {isShowing &&
        <Modal
          hide={toggle} isShowing={isShowing} titulo={titulo} estiloWrapper={{ background: '#000000bf' }}>
          <SeleccionarComponenteModal componente={componenteModal}
            usuario={usuario}
          />
        </Modal>}
        {parametros.screendebug && <ScreenDebug/>}
    </Card>
  );
}

function SeleccionarComponenteModal({ componente, usuario }) {

  switch (componente) {
    case 'asambleas': return <Asambleas />
      break;
    case 'eventos': return <Evento />
      break;
    case 'ejemplo': return <Ejemplo />
      break;
    case 'cupones': return <Cupones />
      break;
    case 'refrescar': return <Ejemplo />
      break;
    case 'tramites': return <Tramites />
      break;
    case 'userpass': return <CambioPassword usuario={usuario} />
      break;
    default: return null
  }
}

  const enviarCodigo = async ()=>{
        const identificador = uuidv4();

        try{
            const envio = await Axios.post(`${process.env.REACT_APP_API_UAD_BASE}/api/tablasgenerales/codigoverificador/movil/${identificador}`,{nombre:'Pablo Stolarczuk test envío',numero:'+5401154943001'})
            Swal.fire('Se envió un SMS de prueba','','info')
            .then(()=>{
                Swal.fire(`Mensaje enviado con éxito.`,'El SMS se envió Pablo St.','success')
            })
          }catch(err){
            console.log(err)
            Swal.fire(`No se pudo enviar el código`,err?.response?.data?.message || '','error')
        }
  }